// extracted by mini-css-extract-plugin
export var btns = "MoveButtons-module--btns--38yKG";
export var topButton = "MoveButtons-module--topButton--1z1vl";
export var arrowDown = "MoveButtons-module--arrowDown--2esPq";
export var arrowUp = "MoveButtons-module--arrowUp--3ccXQ";